export default "__VITE_ASSET__dd873556__"